// planned daily_class status
export const STATUS_PLANNED = 'planned';
export const STATUS_PARTIAL_PLANNED = 'partial_planned';
export const STATUS_PLANNED_WITH_PENDINGS = 'planned_with_pendings';
export const STATUS_NOT_PLANNED = 'not_planned';

export const DAILY_CLASS_PLANNED_STATUS_CONSTRAINTS = [STATUS_PLANNED, STATUS_NOT_PLANNED, STATUS_PLANNED_WITH_PENDINGS, STATUS_PARTIAL_PLANNED];
